import { useCallback, useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useSignal } from "@preact/signals-react"
import { useToast } from "@hooks"
import { isLoadingModal, selectedTable } from "Pages/Admin/ProvidersSuppliersMapping/@signals"

export default function useProviderSuppliersMappingTableData(tableType) {

	const data = useSignal([])
	const isLoading = useSignal(false)
	const { showToast } = useToast()

	const setLoading = () => isLoading.value = !isLoading.value

	const onTableInit = useCallback(() => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.ADMIN}/normalizations/${tableType}`)
			.then(result => {
				data.value = result
				isLoading.value = false
			})
			.catch(() => {
				showToast.error('Could not load table data')
				isLoading.value = false
			})
	}, [tableType])


	useEffect(() => {
		if (!selectedTable.value || selectedTable.value === tableType) onTableInit()
	}, [isLoadingModal.value])

	return {
		data: data.value,
		isLoading: isLoading.value,
		setLoading
	}
}